import { put, takeLatest, call, select } from 'redux-saga/effects';

import { SUBMIT_RATING } from '../actions/types';
import { submitRating as submitRatingAPI } from '../services/rating.js';
import { showSuccessMsg } from '../actions/snackbar';
import { validateSession } from './session';

function* submitRating(action) {
	try {
		const { sessionId } = yield select((state) => state.auth || {});
		yield call(validateSession, submitRatingAPI, action.payload, sessionId);
		yield put(showSuccessMsg('Thank you for the feedback'));
	} catch (error) {
		yield put(showSuccessMsg('Thank you for the feedback'));
	}
}

export function* watchRating() {
	yield takeLatest(SUBMIT_RATING, submitRating);
}
